import { API_BASE } from "@/lib/api";

/** Подложка аватара — основной цвет портала. Раньше оттенок брался хешем от id
 *  пользователя: девять радужных кружков подряд, которые ничего не сообщали
 *  (красный аватар ≠ проблема). Различают людей инициалы, фото и тултип. */
export const AVATAR_BG = "var(--primary)";

export function userInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (name[0] ?? "?").toUpperCase();
}

export function avatarSrc(avatarUrl: string | null | undefined): string | null {
  if (!avatarUrl) return null;
  return `${API_BASE}${avatarUrl.replace(/^\/api/, "")}`;
}

export function UserAvatar({
  name,
  avatarUrl,
  userId,
  size = 28,
  className = "",
  fillBg = false,
  color,
}: {
  name: string;
  avatarUrl?: string | null;
  userId?: string;
  size?: number;
  className?: string;
  // Заливать кружок цветом даже под фото (для фото-вырезок с прозрачным фоном —
  // как карточки в «Пользователях»). По умолчанию под фото фон прозрачный.
  fillBg?: boolean;
  // Явный цвет фона (напр. цвет отдела). Иначе — основной цвет портала.
  color?: string;
}) {
  const src = avatarSrc(avatarUrl);
  const bg = color ?? AVATAR_BG;
  const fontSize = Math.round(size * 0.38);

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full overflow-hidden ${className}`}
      style={{ width: size, height: size, backgroundColor: (src && !fillBg) ? undefined : bg }}
      data-tooltip={name}
    >
      {src
        ? <img src={src} alt={name} className="h-full w-full object-cover" />
        : <span className="font-semibold text-white" style={{ fontSize }}>{userInitials(name)}</span>
      }
    </span>
  );
}
